import React, { useEffect, useState } from "react";
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import IconButton from "@mui/material/IconButton";
import MenuIcon from "@mui/icons-material/Menu";
import Drawer from "@mui/material/Drawer";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemText from "@mui/material/ListItemText";
// import {
//   Avatar,
//   Dialog,
//   DialogContent,
//   DialogActions,
//   Button,
// } from "@mui/material";
import Avatar from "@mui/material/Avatar";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import Button from "@mui/material/Button";
import { useNavigate } from "react-router-dom";
import { t } from "i18next";
import { ArrowDropDownOutlined } from "@mui/icons-material";
import { BookingApi } from "../../../API/Apis/BookingApi";

import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
function CollapsibleNavbar({ isDrawerOpen, toggleDrawer }) {
  const isLogged = localStorage.getItem("isUserLoggedin");
  const [userData, setUserData] = useState({});
  const [loader, setLoader] = useState(true);
  const [showProfileSubMenu, setShowProfileSubMenu] = useState(false);
  const isSmallScreen = window.innerWidth <= 768;
  useEffect(() => {
    document.body.style.overflowX = "hidden";

    return () => {
      document.body.style.overflowX = "";
    };
  }, []);
  function getParentOrigin() {
    try {
      if (
        window.location.ancestorOrigins &&
        window.location.ancestorOrigins.length > 0
      ) {
        return window.location.ancestorOrigins[0];
      }
      if (document.referrer) {
        return new URL(document.referrer).origin;
      }
    } catch (error) {
      console.error("Error in getParentOrigin:", error);
      return "";
    }
  }

  const parentOrigin = getParentOrigin();
  const allowedOrigins = new Set([
    "https://mbrent.mercedes-benz.it",
    "https://bookingmerfina.mbrent.mercedes-benz.it",
    "https://mbrent.mercedes-benz.it/congaratulation",
    "https://merfinatestbooking.myrent.it",
    "https://mauroc147.myrent.it",
  ]);

  const targetOrigin =
    parentOrigin && allowedOrigins.has(parentOrigin) ? parentOrigin : "*";
  const scrollToTop = () => {
    window.parent.postMessage(
      {
        event_id: "scrollToTop",
      },
      targetOrigin
    );
  };

  useEffect(() => {
    const handleMessage = (event) => {
      if (event.data === "openCollapseNavbar") {
        scrollToTop();
        window.scrollTo(0, 0);
        toggleDrawer(true);
      } else if (event.data === "hideCollapseNavbar") {
        toggleDrawer(false);
      }
    };

    window.addEventListener("message", handleMessage);

    return () => {
      window.removeEventListener("message", handleMessage);
    };
  }, []);

  // useEffect(() => {
  //   const id: any = localStorage.getItem("userID");
  //   if (id != null && id != "null" && id != "") {
  //     BookingApi.getUserProfileByUserId(id).then((e) => {
  //       if (e === "Unauthorized access") {
  //         console.log("user is not authorized");
  //       } else if (e?.data?.onlineUser && e?.data?.onlineUser.length > 0) {
  //         setUserData(e?.data?.onlineUser[0]);
  //       }
  //     });
  //   }
  // }, [localStorage.getItem("userID")]);

  const handleUserProfileResponse = (response) => {
    const isUnauthorized = response === "Unauthorized access";
    if (isUnauthorized) {
      console.log("user is not authorized");
      return;
    }
    const onlineUserList = response?.data?.onlineUser;
    const hasOnlineUsers = onlineUserList && onlineUserList.length > 0;
    if (hasOnlineUsers) {
      setUserData(onlineUserList[0]);
      setLoader(false);
    }
  };

  useEffect(() => {
    const id: any = localStorage.getItem("userID");

    if (id != null && id !== "null" && id !== "") {
      BookingApi.getUserProfileByUserId(id).then(handleUserProfileResponse);
    }
  }, [localStorage.getItem("userID")]);

  const toggleProfileSubMenu = () => {
    console.log("clicked");
    setShowProfileSubMenu(!showProfileSubMenu);
  };

  const navigateTo = useNavigate();
  function handleBooking() {
    scrollToTop();
    navigateTo("/myReservedBookings");
  }

  const [open, setOpen] = useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  function handleLogout() {
    BookingApi.logout();
    localStorage.setItem("isUserLoggedin", "false");
    navigateTo("/signin");
  }

  function handleInvoices() {
    scrollToTop();
    navigateTo("/myInvoices");
  }

  function handleCustomerDetails() {
    scrollToTop();
    navigateTo("/customerDetailsList");
  }

  function handleCreateBooking() {
    scrollToTop();
    navigateTo("/");
  }

  function handleProfile() {
    toggleProfileSubMenu();
  }

  function handlePersonalInfo() {
    scrollToTop();
    navigateTo("/profile");
  }

  function handleChangePassword() {
    scrollToTop();
    navigateTo("/changePassword");
  }

  const showNewIFrame = (iframeFor) => {
    window.parent.postMessage(
      {
        event_id: iframeFor,
      },
      targetOrigin
    );
  };

  // --- for mobile ---
  const handleNavbarClick = () => {
    if (isDrawerOpen) {
      showNewIFrame("hideCollapseNavbar");
      toggleDrawer(false);
    } else {
      showNewIFrame("openCollapseNavbar");
      toggleDrawer(true);
    }
  };

  return (
    <div>
      {isSmallScreen && (
        <AppBar
          position="static"
          style={{
            width: "0%",
            backgroundColor: "transparent",
            boxShadow: "none",
            border: "none",
            marginLeft: "2px",
          }}
        >
          <Toolbar>
            <IconButton
              edge="start"
              aria-label="menu"
              onClick={handleNavbarClick}
            >
              <MenuIcon style={{ cursor: "pointer", color: "white" }} />
            </IconButton>
          </Toolbar>
        </AppBar>
      )}
      <Drawer
        anchor="left"
        open={isDrawerOpen}
        onClose={toggleDrawer}
        PaperProps={
          !isSmallScreen
            ? {
                style: {
                  width: "300px",
                  backgroundColor: "black",
                  color: "white",
                },
              }
            : {
                style: {
                  width: "100%",
                  backgroundColor: "white",
                  color: "black",
                  overflowX: "hidden", // Prevents horizontal scrolling
                  marginTop: "45px",
                },
              }
        }
        style={{
          fontFamily: "MBCorpoAScreen1Cond-Regular-Web",
        }}
      >
        {!isSmallScreen && (
          <List style={{ fontFamily: "MBCorpoAScreen1Cond-Regular-Web" }}>
            <ListItem style={{ marginTop: "", marginBottom: "20px" }}>
              <Avatar
                alt={
                  loader ? (
                    <h3 className="!text-center !text-3xl">Loading...</h3>
                  ) : (
                    userData?.firstName || ""
                  )
                }
                src="/assets/images/user.png"
              />

              <ListItemText
                primaryTypographyProps={{
                  style: {
                    fontFamily: "MBCorpoAScreen1Cond-Regular-Web",
                    color: "white",
                  },
                }}
                primary={
                  <span
                    className={`text-[#000] font-poppins_regular text-[20px] ml-4`}
                    style={{
                      fontFamily: "MBCorpoAScreen1Cond-Regular-Web",
                      color: "white",
                    }}
                  >
                    {loader ? (
                      <h5 className="ml-4 text-xl mb-5">Loading...</h5>
                    ) : (
                      `${userData?.firstName || ""} ${userData?.lastName || ""}`
                    )}
                  </span>
                }
              />
            </ListItem>
            <ListItem
              button
              onClick={handleCreateBooking}
              style={{ marginTop: "20px" }}
            >
              <img
                className="h-6"
                src="/assets/images/bookingCreateIcon.png"
                alt="CreateBooking"
                style={{ height: "28px", width: "28px" }}
              />
              <ListItemText
                style={{ marginLeft: "18px" }}
                primaryTypographyProps={{
                  style: {
                    fontFamily: "MBCorpoAScreen1Cond-Regular-Web",
                    color: "white",
                  },
                }}
                primary={t("CreateBooking")}
              />
              {isSmallScreen && <ArrowForwardIosIcon />}
            </ListItem>
            <ListItem button onClick={handleCustomerDetails}>
              <img
                className="h-6"
                src="/assets/images/customerDetailsIcon.png"
                alt="CustomerDetails"
                style={{ height: "16px", width: "22px" }}
              />
              <ListItemText
                style={{
                  marginLeft: "23px",
                  fontFamily: "MBCorpoAScreen1Cond-Regular-Web",
                  color: "white",
                }}
                primaryTypographyProps={{
                  style: {
                    fontFamily: "MBCorpoAScreen1Cond-Regular-Web",
                    color: "white",
                  },
                }}
                primary={t("Customer Details")}
              />
              {isSmallScreen && <ArrowForwardIosIcon />}
            </ListItem>
            <ListItem button onClick={handleBooking}>
              <img
                src="/assets/images/reservationIcon.png"
                alt="Reservation"
                style={{ height: "26px", width: "24px" }}
              />
              <ListItemText
                style={{
                  marginLeft: "23px",
                  fontFamily: "MBCorpoAScreen1Cond-Regular-Web",
                  color: "white",
                }}
                primaryTypographyProps={{
                  style: {
                    fontFamily: "MBCorpoAScreen1Cond-Regular-Web",
                    color: "white",
                  },
                }}
                primary={t("Reservation")}
              />
              {isSmallScreen && <ArrowForwardIosIcon />}
            </ListItem>
            <ListItem button onClick={handleInvoices}>
              <img
                src="/assets/images/invoiceBookIcon.png"
                alt="List of invoice"
                style={{ height: "24px", width: "24px" }}
              />
              <ListItemText
                style={{
                  marginLeft: "22px",
                  fontFamily: "MBCorpoAScreen1Cond-Regular-Web",
                  color: "white",
                }}
                primaryTypographyProps={{
                  style: {
                    fontFamily: "MBCorpoAScreen1Cond-Regular-Web",
                    color: "white",
                  },
                }}
                primary={t("Invoice")}
              />
              {isSmallScreen && <ArrowForwardIosIcon />}
            </ListItem>
            <ListItem button onClick={handleProfile}>
              <img
                src="/assets/images/proLogo.jpg"
                alt="Profile"
                style={{ height: "26px", width: "26px" }}
              />
              <span
                style={{
                  marginLeft: "22px",
                  color: "primary",
                  fontWeight: "bold",
                  fontFamily: "MBCorpoAScreen1Cond-Regular-Web",
                }}
              >
                {t("Profile")}
              </span>
              <ArrowDropDownOutlined
                style={{ marginLeft: "auto", cursor: "pointer" }}
                onClick={toggleProfileSubMenu}
              />
              {isSmallScreen && <ArrowForwardIosIcon />}
            </ListItem>
            {showProfileSubMenu && (
              <>
                <ListItem button onClick={handlePersonalInfo}>
                  <ListItemText
                    style={{
                      marginLeft: "45px",
                      fontFamily: "MBCorpoAScreen1Cond-Regular-Web",
                      color: "white",
                    }}
                    primaryTypographyProps={{
                      style: {
                        fontFamily: "MBCorpoAScreen1Cond-Regular-Web",
                        color: "white",
                      },
                    }}
                    primary={t("Personal information")}
                  />
                </ListItem>
                <ListItem button onClick={handleChangePassword}>
                  <ListItemText
                    style={{
                      marginLeft: "45px",
                      fontFamily: "MBCorpoAScreen1Cond-Regular-Web",
                      color: "white",
                    }}
                    primaryTypographyProps={{
                      style: {
                        fontFamily: "MBCorpoAScreen1Cond-Regular-Web",
                        color: "white",
                      },
                    }}
                    primary={t("Change Password")}
                  />
                </ListItem>
              </>
            )}
            <ListItem button onClick={handleClickOpen}>
              <img
                className="h-6"
                src="/assets/images/LogoutIcon.png"
                alt="LogoutIcon"
                style={{ height: "24px", width: "24px" }}
              />
              <ListItemText
                style={{
                  marginLeft: "22px",
                  fontFamily: "MBCorpoAScreen1Cond-Regular-Web",
                  color: "white",
                }}
                primaryTypographyProps={{
                  style: {
                    fontFamily: "MBCorpoAScreen1Cond-Regular-Web",
                    color: "white",
                  },
                }}
                primary={t("Logout")}
              />
              {isSmallScreen && <ArrowForwardIosIcon />}
            </ListItem>
          </List>
        )}
        {/* Mobile navbar */}
        {isSmallScreen && (
          <List
            style={{
              fontFamily: "MBCorpoAScreen1Cond-Regular-Web",
            }}
          >
            <ListItem
              button
              onClick={() => {
                toggleDrawer();
                showNewIFrame("showIFrameForBooking");
              }}
            >
              <ListItemText
                primaryTypographyProps={{
                  style: {
                    fontFamily: "MBCorpoAScreen1Cond-Regular-Web",
                    color: "black",
                    fontSize: "18px",
                  },
                }}
                primary={t("Home")}
              />
              {isSmallScreen && <ArrowForwardIosIcon />}
            </ListItem>
            <hr />

            <ListItem
              button
              onClick={() => {
                toggleDrawer();
                showNewIFrame("showNewIFrameForDealer");
              }}
            >
              <ListItemText
                primaryTypographyProps={{
                  style: {
                    fontFamily: "MBCorpoAScreen1Cond-Regular-Web",
                    color: "black",
                    fontSize: "18px",
                  },
                }}
                primary={t("Dealer")}
              />
              {isSmallScreen && <ArrowForwardIosIcon />}
            </ListItem>
            <hr />

            <ListItem
              button
              onClick={() => {
                toggleDrawer();
                showNewIFrame("showNewIFrameForContact");
              }}
            >
              <ListItemText
                primaryTypographyProps={{
                  style: {
                    fontFamily: "MBCorpoAScreen1Cond-Regular-Web",
                    color: "black",
                    fontSize: "18px",
                  },
                }}
                primary={t("Contact Us")}
              />
              {isSmallScreen && <ArrowForwardIosIcon />}
            </ListItem>
            <hr />

            {isLogged == "true" && (
              <>
                <h2
                  className="total-price md:text-md text-sm whitespace-nowrap font-normal"
                  style={{
                    marginLeft: "4%",
                    width: "70%",
                    fontFamily: "MBCorpoAScreen1Cond-Regular-Web",
                    fontSize: "20px",
                    marginTop: "10px",
                    fontWeight: "bold",
                    color: "#0078D6",
                  }}
                >
                  {t("Reserve Area")}
                </h2>
                <ListItem
                  button
                  onClick={() => {
                    toggleDrawer();
                    showNewIFrame("showIFrameForBooking");
                  }}
                >
                  <ListItemText
                    primaryTypographyProps={{
                      style: {
                        fontFamily: "MBCorpoAScreen1Cond-Regular-Web",
                        color: "black",
                        fontSize: "18px",
                      },
                    }}
                    primary={t("CreateBooking")}
                  />
                  {isSmallScreen && <ArrowForwardIosIcon />}
                </ListItem>
                <hr />
                <ListItem
                  button
                  onClick={() => {
                    toggleDrawer();
                    handleCustomerDetails();
                  }}
                >
                  <ListItemText
                    style={{
                      fontFamily: "MBCorpoAScreen1Cond-Regular-Web",
                      color: "black",
                    }}
                    primaryTypographyProps={{
                      style: {
                        fontFamily: "MBCorpoAScreen1Cond-Regular-Web",
                        color: "black",
                        fontSize: "18px",
                      },
                    }}
                    primary={t("Customer Details")}
                  />
                  {isSmallScreen && <ArrowForwardIosIcon />}
                </ListItem>
                <hr />
                <ListItem
                  button
                  onClick={() => {
                    toggleDrawer();
                    handleBooking();
                  }}
                >
                  <ListItemText
                    style={{
                      fontFamily: "MBCorpoAScreen1Cond-Regular-Web",
                      color: "black",
                    }}
                    primaryTypographyProps={{
                      style: {
                        fontFamily: "MBCorpoAScreen1Cond-Regular-Web",
                        color: "black",
                        fontSize: "18px",
                      },
                    }}
                    primary={t("Reservation")}
                  />
                  {isSmallScreen && <ArrowForwardIosIcon />}
                </ListItem>
                <hr />
                <ListItem
                  button
                  onClick={() => {
                    toggleDrawer();
                    handleInvoices();
                  }}
                >
                  <ListItemText
                    style={{
                      fontFamily: "MBCorpoAScreen1Cond-Regular-Web",
                      color: "black",
                    }}
                    primaryTypographyProps={{
                      style: {
                        fontFamily: "MBCorpoAScreen1Cond-Regular-Web",
                        color: "black",
                        fontSize: "18px",
                      },
                    }}
                    primary={t("Invoice")}
                  />
                  {isSmallScreen && <ArrowForwardIosIcon />}
                </ListItem>
                <hr />
                <ListItem button onClick={handleProfile}>
                  <span
                    style={{
                      fontFamily: "MBCorpoAScreen1Cond-Regular-Web",
                      color: showProfileSubMenu ? "#0078D6" : "black",
                      fontSize: "18px",
                    }}
                  >
                    {t("Profile")}
                  </span>
                  <ArrowForwardIosIcon
                    style={{
                      transform: showProfileSubMenu
                        ? "rotate(-90deg)"
                        : "rotate(90deg)",
                      cursor: "pointer",
                      marginLeft: "auto",
                      width: "27px",
                      color: showProfileSubMenu ? "#0078D6" : "black",
                    }}
                    onClick={toggleProfileSubMenu}
                  />
                </ListItem>
                <hr />

                {showProfileSubMenu && (
                  <>
                    <ListItem button onClick={handlePersonalInfo}>
                      <ListItemText
                        style={{
                          fontFamily: "MBCorpoAScreen1Cond-Regular-Web",
                          color: "black",
                        }}
                        primaryTypographyProps={{
                          style: {
                            fontFamily: "MBCorpoAScreen1Cond-Regular-Web",
                            color: "black",
                            fontSize: "18px",
                          },
                        }}
                        primary={t("Personal information")}
                      />
                      {isSmallScreen && <ArrowForwardIosIcon />}
                    </ListItem>
                    <ListItem button onClick={handleChangePassword}>
                      <ListItemText
                        style={{
                          fontFamily: "MBCorpoAScreen1Cond-Regular-Web",
                          color: "black",
                        }}
                        primaryTypographyProps={{
                          style: {
                            fontFamily: "MBCorpoAScreen1Cond-Regular-Web",
                            color: "black",
                            fontSize: "18px",
                          },
                        }}
                        primary={t("Change Password")}
                      />
                      {isSmallScreen && <ArrowForwardIosIcon />}
                    </ListItem>
                  </>
                )}
                <hr />
                <ListItem button onClick={handleClickOpen}>
                  <ListItemText
                    style={{
                      fontFamily: "MBCorpoAScreen1Cond-Regular-Web",
                      color: "black",
                    }}
                    primaryTypographyProps={{
                      style: {
                        fontFamily: "MBCorpoAScreen1Cond-Regular-Web",
                        color: "black",
                        fontSize: "18px",
                      },
                    }}
                    primary={t("Logout")}
                  />
                  {isSmallScreen && <ArrowForwardIosIcon />}
                </ListItem>
                <hr />
              </>
            )}
          </List>
        )}
      </Drawer>

      {/* Logout Confirmation Modal */}
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="logout-confirmation-title"
        aria-describedby="logout-confirmation-description"
        PaperProps={{
          sx: {
            width: !isSmallScreen ? "500px" : "90%",
            maxWidth: "600px",
            padding: !isSmallScreen ? "20px" : "10px",
          },
        }}
      >
        <DialogContent>{t("Are you sure you want to log out?")}</DialogContent>
        <DialogActions
          sx={{
            justifyContent: "center",
          }}
        >
          <Button
            onClick={handleClose}
            variant="outlined"
            sx={{
              gap: 1,
              fontWeight: "bold",
              borderColor: "#7B7B7B",
              textTransform: "capitalize",
              padding: "4px 8px",
            }}
            style={{
              color: "#7B7B7B",
              minWidth: "100px",
            }}
          >
            {t("Cancel")}
          </Button>
          <Button
            onClick={handleLogout}
            type="submit"
            variant="contained"
            sx={{
              gap: 1,
              fontWeight: "bold",
              bgcolor: "#0078D6",
              textTransform: "capitalize",
              padding: "4px 8px",
            }}
            style={{
              backgroundColor: "#0078D6",
              minWidth: "100px",
            }}
          >
            {t("Logout")}
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}

export default CollapsibleNavbar;
